<div class="card-body">
  <div class="row">
    <div class="col-md-12">
      <!-- <section class="example-full-width" *ngFor="let platformGroupRolePermission of platformGroupRolePermissions">
        <mat-slide-toggle color="primary" [(ngModel)]="platformGroupRolePermission.permissionValue" (change)="onChange(platformGroupRolePermission,$event)"
          labelPosition="before">{{platformGroupRolePermission.displayName}}</mat-slide-toggle> 
      </section> -->
      <section class="example-full-width" *ngFor="let projectPermission of projectPermissions">
        <mat-slide-toggle color="primary" [(ngModel)]="projectPermission.permissionValue" (change)="onChange()"
          >{{projectPermission.displayName}}</mat-slide-toggle> 
      </section>
    </div>
  </div>
</div>